import React, { useEffect, useState } from "react";
import { getValueParamsIsShop, Section_Click } from "../../utils/utils";
import { InteractiveResult } from "../SearchResults/SearchListing/InteractiveResult";
import {globalStandaloneSearchBox} from "../../controllers/seachBoxControllers";

function Suggestions(props: any) {
  const [valueRedirect, setValueRedirect] = useState("");
  useEffect(()=>{
    async function getValueRedirect(){
      let valueParamsIsShop: string =  await getValueParamsIsShop();
      setValueRedirect(valueParamsIsShop)
    }
    getValueRedirect();
  });
  return (
    <div className={props.className}>
      <div className="left">{props.label}</div>
      <div className="right">
        {props.label === "Top Searches" &&
          props.suggestions &&
          props.suggestions.map((result: any, index: number) => (
            <div className="result" key={'top-searches-' + index}>
              <a
                  onClick={() => {
                      globalStandaloneSearchBox.selectSuggestion(result.rawValue);
                      localStorage.setItem("analytics", JSON.stringify(globalStandaloneSearchBox.state.analytics));
                      localStorage.setItem("searchSuggestion", result.rawValue);
                  }}
                href={props.searchPage + "?q=" + result.rawValue + "&r=" + valueRedirect}
                dangerouslySetInnerHTML={{
                  __html: result.highlightedValue,
                }}
              ></a>
            </div>
          ))}
        {props.results &&
          props.results.map(
            // Used for Resources section
            (result: any, index: number) =>
              index < props.items && (
                <div className="result" key={'resources-' + index}>
                  {props.highlightedValue && props.highlightedValue.length > 0 && (
                    <InteractiveResult
                      sectionClick={Section_Click.RESOURCES}
                      highlightedValue={props.highlightedValue[index]}
                      result={result}
                    />
                  )}
                </div>
              )
          )}
      </div>
    </div>
  );
}

export default Suggestions;
